import BaseTableCell from '@tiptap/extension-table-cell'
import { Plugin } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

import { DEFAULT_COL_WIDTH } from './constants.js'
import { parseHTMLColWidth } from './helpers/colwidth.js'
import {
  getCellsInColumn,
  isRowSelected,
  isTableSelected,
  selectRow,
  selectTable,
} from './utils.js'

const className = 'relative border p-2 min-h-6 align-top [&_p]:m-0'

export const TableCell = BaseTableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: className,
      },
      colwidth: {
        default: [DEFAULT_COL_WIDTH],
        parseHTML: parseHTMLColWidth,
      },
    }
  },
  addProseMirrorPlugins() {
    const { isEditable } = this.editor

    return [
      new Plugin({
        props: {
          decorations: state => {
            if (!isEditable) {
              return DecorationSet.empty
            }

            const { doc, selection } = state
            const decorations: Decoration[] = []
            const cells = getCellsInColumn(0)(selection)

            if (cells) {
              cells.forEach(({ pos }: { pos: number }, index: number) => {
                decorations.push(
                  Decoration.widget(pos + 1, () => {
                    const rowSelected = isRowSelected(index)(selection)
                    let className = 'grip-row'

                    if (rowSelected) {
                      className += ' selected'
                    }

                    if (index === 0) {
                      className += ' first'
                    }

                    if (index === cells.length - 1) {
                      className += ' last'
                    }

                    const grip = document.createElement('a')

                    grip.className = className
                    grip.addEventListener('mousedown', event => {
                      event.preventDefault()
                      event.stopImmediatePropagation()

                      this.editor.view.dispatch(
                        selectRow(index)(this.editor.state.tr),
                      )
                    })

                    return grip
                  }),
                )
              })

              const firstCell = cells.at(0)

              if (firstCell) {
                decorations.push(
                  Decoration.widget(firstCell.pos + 1, () => {
                    const tableSelected = isTableSelected(selection)
                    let className = 'grip-table'

                    if (tableSelected) {
                      className += ' selected'
                    }

                    const grip = document.createElement('a')

                    grip.className = className
                    grip.addEventListener('mousedown', event => {
                      event.preventDefault()
                      event.stopImmediatePropagation()

                      this.editor.view.dispatch(
                        selectTable(this.editor.state.tr),
                      )
                    })

                    return grip
                  }),
                )
              }
            }

            return DecorationSet.create(doc, decorations)
          },
        },
      }),
    ]
  },
})
